import React from 'react';

class ErrorUtils {
  static mlflowServices = {
    MODEL_REGISTRY: 'Model Registry',
    EXPERIMENTS: 'Experiments',
    MODEL_SERVING: 'Model Serving',
    RUN_TRACKING: 'Run Tracking',
  };
}

export default ErrorUtils;
